// extracted by mini-css-extract-plugin
export default {"addressForm":"AdressFormBasic_addressForm__I215G","subAddress":"AdressFormBasic_subAddress__JGGgq","formInput":"AdressFormBasic_formInput__EuENl"};